<script setup>
import { ref, toRefs, onMounted } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseDatePicker from '@/src/vueComponent/BaseDatePicker.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import dayjs from 'dayjs'

const props = defineProps({
  companyType: {
    type: String
  }
})

const { companyType } = toRefs(props)

const determinePartnerUrl = () => {
  if (companyType.value === 'Customer') {
    return '/customer/public_data'
  } else if (companyType.value === 'Supplier') {
    return '/supplier/public_data'
  }
}

const searchInfo = ref({
  keyword: '',
  start_date: '',
  end_date: ''
})

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.keyword = searchParams.get('keyword')
  searchInfo.value.start_date = searchParams.get('start_date')
  searchInfo.value.end_date = searchParams.get('end_date')
})

const checkDateConverse = () => {
  return dayjs(searchInfo.value.start_date).isAfter(dayjs(searchInfo.value.end_date))
}

const checkDateOnlyOneChosen = () => {
  return (
    (searchInfo.value.start_date && !searchInfo.value.end_date) ||
    (!searchInfo.value.start_date && searchInfo.value.end_date)
  )
}

const handleSubmit = (event) => {
  if (checkDateOnlyOneChosen()) {
    mySwal.error({
      title: '請選擇一個日期區間'
    })
    event.preventDefault()
  } else if (checkDateConverse()) {
    mySwal.error({
      title: '起始日期不得晚於結束日期'
    })
    event.preventDefault()
  }
}
</script>

<template>
  <form
    class="min-w-[248px] p-4"
    :action="determinePartnerUrl()"
    accept-charset="UTF-8"
    method="get"
    @submit="handleSubmit"
  >
    <div class="mb-2">
      <BaseTextInput
        :label="'關鍵字'"
        :name="'keyword'"
        v-model="searchInfo.keyword"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（起）'" :name="'start_date'" v-model="searchInfo.start_date" />
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（迄）'" :name="'end_date'" v-model="searchInfo.end_date" />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a :href="determinePartnerUrl()" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
<style scoped>
.anticon {
  display: inline-flex;
}
</style>
